import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

export interface ModalSettings {
  title?: string;
  closeLabel?: string;
  onClose?: (reason: string) => any;
  classes?: string;
  backdrop?: string;
  keyboard?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  bsModalRef?: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private toasterService: ToastrService
  ) {}

  openModalWithComponent(
    component: any,
    settings: ModalSettings = {},
    state?: any
  ): BsModalRef<any> {
    const { title = '', closeLabel = '', onClose, classes = '' } = settings;

    let initialState: ModalOptions;
    if (state) {
      initialState = {
        class: 'mysign-modal modal-dialog-centered ' + classes,
        animated: true,
        focus: true,
        backdrop: 'static',
        keyboard: true,
      };
    } else {
      initialState = {
        class: 'mysign-modal modal-dialog-centered ' + classes,
        animated: true,
        focus: true,
      };
    }

    console.log('settings', { settings, initialState });

    this.bsModalRef = this.modalService.show(component, initialState);
    this.bsModalRef.content = {
      title,
      closeLabel,
      onClose,
    };
    this.closeModalActions(this.bsModalRef);
    return this.bsModalRef;
    //this.bsModalRef.content.closeBtnName = 'Close';
  }

  closeModal() {
    this.modalService.hide();
  }

  closeModalActions(bsModalRef: BsModalRef<any>) {
    // Qui puoi inserire le azioni che vuoi eseguire al momento della chiusura
    bsModalRef.onHidden.subscribe(() => {
      this.toasterService.clear();
    });
  }
}
